var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCurrencies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .svg-currency-text {font-size:19px;font-weight:400}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-837 -889.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(838.5 891)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff",
    strokeWidth: "3px"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg-currency-text",
    "data-name": "$",
    transform: "translate(14.25 21.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.7,
    y: 0
  }, "$"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(864.5 891)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff",
    strokeWidth: "3px"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg-currency-text",
    "data-name": "\\xA3",
    transform: "translate(14.25 21.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.7,
    y: 0
  }, "\xA3"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(890.5 891)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff",
    strokeWidth: "3px"
  }), /*#__PURE__*/React.createElement("text", {
    className: "svg-currency-text",
    "data-name": "\\u20AC",
    transform: "translate(14.25 21.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.7,
    y: 0
  }, "\u20AC"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrencies);
export default __webpack_public_path__ + "static/media/icon-currencies.3ed4bed2b450e7c03272f6c829812759.svg";
export { ForwardRef as ReactComponent };